

// src/slice/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { data } from 'autoprefixer';

// Define the API slice
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://mecfuture.mec.edu.om/api/', // Base URL for your API
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('nlms-api-key', '0612b32b39f4b29f48c5c5363028ee916bb99Singularis');

      // Add Authorization token from localStorage if it exists
      const token = localStorage.getItem('token') || '';
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    enrollmentsSourceEnrollment: builder.query({
      query: (data) => ({
        url: 'mec-bd-enrollments',
        method: 'GET',
        body: data,
      }),
    }),
    enrollmentsYearSource: builder.query({
      query: (year) => ({
        url: 'mec-bd-enrollments-year-source',
        method: 'POST',
        body: { year },
      }),
    }),
    enrollmentsSource: builder.query({
      query: (year) => ({
        url: 'mec-bd-enrollments-source',
        method: 'POST',
        body: { year },
      }),
    }),
    enrollmentsYear: builder.query({
      query: (enrollmentSource) => ({
        url: 'mec-bd-enrollments-year',
        method: 'POST',
        body: { enrollmentSource },
      }),
    }),


    getLeadConversion: builder.query({
      query: (year) => ({
        url: 'mec-bd-lead-conversion',
        method: 'POST',
        body: { year },

      }),
    }),

    getEnrollments: builder.query({
      query: () => ({
        url: 'mec-bd-enrollments-source-enrollement',
        method: 'POST',
      }),
    }),

    getProgramList: builder.query({
      query: (data) => ({
        url: 'mec-bd-program-list',
        method: 'POST',
        body: data,
      }),
    }),

    getEventDashboard: builder.query({
      query: () => ({
        url: 'mec-bd-event-graph',
        method: 'POST',
      }),
    }),
    getEventEnrollment: builder.query({
      query: () => ({
        url: 'mec-bd-event-enrollment',
        method: 'POST',
      }),
    }),
    getMecBDEmp: builder.query({
      query: (data) => ({
        url: 'mec-bd-emp',
        method: 'POST',
        body: data,
      }),
    }),
    getMecBDDashboard: builder.query({
      query: (data) => ({
        url: 'mec-bd-emp-dashboard',
        method: 'POST',
        body: data,
      }),
    }),
    getUser: builder.query({
      query: () => ({
        url: '/mec-bd-user-list',
        method: 'POST',
      }),
    }),
    getAddmission: builder.query({
      query: () => ({
        url: '/mec-bd-student-university',
        method: 'POST',
      }),
    }),

    getStudentCourse: builder.query({
      query: () => ({
        url: '/mec-bd-student-course',
        method: 'POST',
      }),
    }),

    getStudentDistribution: builder.query({
      query: () => ({
        url: '/mec-bd-student-distribution',
        method: 'POST',
      }),
    }),
    getTopSponsor: builder.query({
      query: () => ({
        url: '/mec-bd-top-sponsor',
        method: 'POST',
      }),
    }),
    getTopSpecializations: builder.query({
      query: (data) => ({
        url: '/mec-bd-top-specializations',
        method: 'POST',
        body: data,
      }),
    }),
    getStudentSummary: builder.query({
      query: (data) => ({
        url: '/mec-bd-top-student-summary',
        method: 'POST',
        body: data,
      }),
    }),
    programSponsor: builder.query({
      query: (data) => ({
        url: '/mec-bd-program-sponsor',
        method: 'POST',
        body: data,
      }),
    }),
    crm: builder.query({
      query: (data) => ({
        url: '/mec-bd-crm',
        method: 'POST',
        body: data,
      }),
    }),
    financeDashboard: builder.query({
      query: () => ({
        url: '/mec-bd-finance-dashboard',
        method: 'POST',
      })
    }),
    financePage2: builder.query({
      query: () => ({
        url: '/mec-bd-finance-graph',
        method: 'POST',
      })
    }),
    communityDashboard: builder.query({
      query: () => ({
        url: '/mec-bd-community-dashboard',
        method: 'POST',
      })
    }),
    communityContributers: builder.query({
      query: (data) => ({
        url: '/mec-bd-community-contributers',
        body: data,
        method: 'POST',
      })
    }),
    userCreate: builder.mutation({
      query: (data) => ({
        url: '/mec-bd-user-create',
        body: data,
        method: 'POST',
      })
    }),
    userUpdate: builder.mutation({
      query: (data) => ({
        url: '/mec-bd-user-update',
        body: data,
        method: 'POST',
      })
    }),
    employabilityDetails: builder.query({
      query: (data) => ({
        url: '/mec-bd-emp-dashboard',
        body: data,
        method: 'POST',
      })
    }),
    academicSummary: builder.query({
      query: () => ({
        url: '/mec-bd-academy',
       method: 'POST',
      })
    }),
    academicPrograms: builder.query({
      query: () => ({
        url: '/mec-bd-academy-program',
       method: 'POST',
      })
    }),



  }),
});





// Export the auto-generated hooks
export const {

  useEnrollmentsSourceEnrollmentQuery,
  useEnrollmentsYearSourceQuery,
  useEnrollmentsSourceQuery,
  useEnrollmentsYearQuery,
  useGetEnrollmentsQuery,
  useGetLeadConversionQuery,
  useGetProgramListQuery,
  useGetEventDashboardQuery,
  useGetEventEnrollmentQuery,
  useGetMecBDEmpQuery,
  useGetMecBDDashboardQuery,
  useGetUserQuery,
  useGetAddmissionQuery,
  useGetStudentCourseQuery,
  useGetStudentDistributionQuery,
  useGetTopSponsorQuery,
  useGetTopSpecializationsQuery,
  useGetStudentSummaryQuery,
  useProgramSponsorQuery,
  useCrmQuery,
  useFinanceDashboardQuery,
  useFinancePage2Query,
  useCommunityContributersQuery,
  useCommunityDashboardQuery,
  useUserCreateMutation,
  useEmployabilityDetailsQuery,
  useAcademicSummaryQuery,
  useAcademicProgramsQuery,
  useUserUpdateMutation,



} = apiSlice;
